module.exports = __webpack_public_path__ + "static/media/or-en.798850e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/or-en.svg
// module id = 1267
// module chunks = 0